import React from "react";
import { createRoot } from "react-dom/client";
import reportWebVitals from "./reportWebVitals";
import CKService from "./mba-services";
const widgetsMap = [{ rootid: "root", reactComponent: <CKService /> }];

widgetsMap.map(({ rootid, reactComponent }) => {
  const container = document.getElementById(rootid);
  if (container) {
    createRoot(container).render(reactComponent);
  }
  return true;
});
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
